import { useEffect } from 'react';
import ReactGA from 'react-ga4';

/**
 * Hook per inizializzare Google Analytics 4 per l'applicazione Iniettore
 */
export const useGoogleAnalytics = () => {
  const GA_MEASUREMENT_ID = import.meta.env.VITE_GA_MEASUREMENT_ID;

  useEffect(() => {
    if (GA_MEASUREMENT_ID) {
      ReactGA.initialize(GA_MEASUREMENT_ID, {
        gaOptions: {
          anonymizeIp: true,
        },
      });

      // Traccia pageview per l'app Iniettore
      ReactGA.send({
        hitType: 'pageview',
        page: '/Iniettore',
        title: 'Iniettore - Simulatore Diesel'
      });

      console.log('Google Analytics inizializzato per Iniettore con ID:', GA_MEASUREMENT_ID);
    } else {
      console.warn('Google Analytics non configurato: VITE_GA_MEASUREMENT_ID mancante');
    }
  }, [GA_MEASUREMENT_ID]);
};

/**
 * Traccia eventi personalizzati
 */
export const trackEvent = (category: string, action: string, label?: string, value?: number) => {
  const GA_MEASUREMENT_ID = import.meta.env.VITE_GA_MEASUREMENT_ID;
  if (GA_MEASUREMENT_ID) {
    ReactGA.event({
      category,
      action,
      label,
      value,
    });
    console.log('GA Event (Iniettore):', { category, action, label, value });
  }
};
